export const DEMO_INFO: string = "DEMO_INFO";
export const DEMO_INFO_SUCCESS: string = "DEMO_INFO_SUCCESS";
export const DEMO_INFO_FAIL: string = "DEMO_INFO_FAIL";
export const RESET_DEMO_INFO: string = "RESET_DEMO_INFO";
